import { useConfig } from '../hooks';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { SyntheticEvent } from 'react';
import _ from 'lodash';
import { useGetProfileEventProgress } from '~components/hooks';
import { Timer } from '~components/event';
import Currency from '~components/Currency';
import { Price } from '~ui/index';

export const EventBanner = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const getConfig = useConfig();
  const getEvent = getConfig?.getEvent;

  const { data, loading, error } = useGetProfileEventProgress(getEvent?.id, {
    ssr: false,
  });

  const getProfile = data?.getProfile;

  const onClick = (event: SyntheticEvent) => {
    event.preventDefault();

    navigate(getConfig?.getEvent.getUrl);
  };

  if (!getConfig?.getEvent) {
    return null;
  }

  if (getEvent?.isEndend) {
    return null;
  }

  if (
    loading ||
    !getProfile?.getEventProgress ||
    !getProfile?.isPlayEvent ||
    !getProfile.getEventProgress
  ) {
    return null;
  } else if (error) {
    return <>EventBanner | Error! {error.message}</>;
  }

  const { nextRank, getNextItem, countOpen, spent, nextPrizeSpent } =
    getProfile.getEventProgress;

  const title =
    _.get(getEvent, `props[${language}].h1`) ||
    t('Event_Title', { eventName: getEvent?.props?.h1 });

  return (
    <div className="case-breezy">
      <div className="event-images-wrap">
        <img className="event-images" src={getEvent?.props?.background} />
      </div>
      <div className="case-breezy-container">
        <div className="case-breezy-timer" onClick={onClick}>
          <div className="case-breezy-timer-title">{title}</div>
          <Timer
            endDate={getEvent.endDate}
            isEndend={getEvent?.isEndend}
            isLaunched={getEvent?.isLaunched}
          />
          <div className="timer-to-end">
            <span>{t('case-breezy timer-to-end')}:</span>
          </div>
        </div>
        <div className="case-breezy-stats">
          <div className="case-breezy-stats-item">
            <div className="case-breezy-stats-num">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.0009 16.0001V14.0003H10.0004V16.0001H6.00094C6.00094 16.0001 6.01168 14.9732 6.00094 12.0003C5.98995 9.02666 8.44601 7.99175 10.0004 7.9998C11.5546 8.00786 21.0002 7.9998 21.0002 7.9998C21.0002 7.9998 18.978 9.00151 19.0004 12.0003C19.0239 14.9991 19.0004 16.0001 19.0004 16.0001H15.0009ZM26.0004 16.0001V16.0967C26.0004 16.0967 26.0004 16.0723 26.0004 16.0001ZM20.0002 12.0003C20.0092 6.87479 26.0051 6.918 26.0007 12.0003C25.9975 14.8052 25.998 15.7322 25.9987 16H20.0002C20.0002 16 19.9995 16.1048 19.9985 16.1048C19.9965 16.1048 19.9941 15.5613 20.0002 12.0003ZM12.0012 16.9998H13.0009V16.0001H12.0012V16.9998ZM13.9992 18.0008H11.0012V15.0001H14V17.9988L13.9992 18.0008ZM6.00094 25.0001V16.9998H10.0004V19.0005H15.0009V16.9998H19.0004V25.0001H6.00094ZM19.9968 25.0001V16.9998H26.0232V25.0001H19.9968Z"
                  fill="url(#paint0_linear_3175_69484)"
                ></path>
                <defs>
                  <linearGradient
                    id="paint0_linear_3175_69484"
                    x1="36.039"
                    y1="16.4999"
                    x2="19.2598"
                    y2="-3.26206"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#FF9C0E"></stop>
                    <stop offset="1" stopColor="#FFD800"></stop>
                  </linearGradient>
                </defs>
              </svg>
              <span>{countOpen}</span>
            </div>
            <div className="case-breezy-stats-label">{t('case_two')}</div>
          </div>
          <div className="case-breezy-stats-item">
            <div className="case-breezy-stats-num">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12.0008 7.99976C12.0152 5.19361 14.0016 6 14.0016 6C14.0016 6 14.6622 5 16.0013 5C16.9203 5 18.0011 6 18.0011 6C18.0011 6 19.9955 5.02441 20.0008 7.99976C20.0072 10.9751 17.9344 13 16.0013 13C14.0682 13 11.9874 10.8059 12.0008 7.99976ZM18.0011 19.0059C17.4432 19.0032 17.0218 19.0012 16.6744 19.0012C16.3873 19.0012 16.1615 19.0022 15.9427 19.0032L15.8385 19.0039H15.6639L15.5809 19.0049C15.4801 19.0049 15.3748 19.0059 15.2606 19.0059C15.2218 19.0059 15.1822 19.0059 15.1417 19.0049C15.0985 19.0049 15.0545 19.0049 15.0086 19.0049L15.0013 19.0059V16.0051H15.0123C15.2542 16.0034 15.7638 16.0017 16.453 16.0017C17.067 16.0017 17.5448 16.0024 18.0011 16.0051C18.8983 16.0105 19.3043 16.7927 19.3016 17.5181C19.2999 18.2346 18.8949 19.0059 18.0091 19.0059H18.0011ZM12.0008 22.0056H14.0016V24.0054H15.0006L15.0013 22.0056H17.0011V21.0056H15.0013V20.0056C15.0184 20.0056 15.1598 20.0066 15.9229 20.0066C16.3675 20.0066 17.0265 20.0066 18.0011 20.0056C19.504 20.0056 20.1925 18.7161 20.1954 17.5171C20.1971 16.312 19.5104 15.0125 18.0011 15.0054C17.1686 15.0017 16.3829 15 15.6639 15C14.6766 15 14.2301 15.0034 14.1168 15.0044H14.0123L14.0016 15.0054V19.0059H12.0008V20.0056H14.0016V21.0056H12.0008V22.0056ZM9.75083 25.242C7.89683 24.3987 7.0228 22.7327 7.00132 20.0002C6.97617 16.9116 8.33701 14.9009 9.48252 13.7578C10.7164 12.5286 11.9891 12.0047 12.0018 12.0003C12.0223 12.02 14.0968 14 16.0013 14C17.9056 14 19.9801 12.02 20.0008 12.0003C20.1351 12.0569 21.3158 12.5798 22.4876 13.7578C23.6234 14.9009 24.9823 16.9116 25.0013 20.0002C25.013 21.9668 24.5594 23.3853 23.6126 24.3374C21.961 25.9998 19.0658 25.9998 16.0013 25.9998C13.6441 25.9998 11.4176 25.9998 9.75083 25.242Z"
                  fill="url(#paint0_linear_3175_69492)"
                ></path>
                <defs>
                  <linearGradient
                    id="paint0_linear_3175_69492"
                    x1="34.0061"
                    y1="15.4998"
                    x2="13.2484"
                    y2="-2.29332"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#FF9C0E"></stop>
                    <stop offset="1" stopColor="#FFD800"></stop>
                  </linearGradient>
                </defs>
              </svg>
              <span>
                <Price sum={spent} />{' '}
                <span className="cur">
                  <Currency />
                </span>
              </span>
            </div>
            <div className="case-breezy-stats-label">
              {t('breezy-progress breezy-profile-stats-label 1')}
            </div>
          </div>
          {nextRank && (
            <div className="case-breezy-stats-item">
              <div className="case-breezy-stats-num">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 9.67219H16V14.9915H25V9.67219H21.5922L21.5949 9.66725C21.7874 9.31486 22 8.92563 22 8.49765C22 7.12736 20.7735 6 19.393 6C17.001 6 15.501 8.49753 15.501 8.49753C15.501 8.49753 14.001 6 11.607 6C10.2265 6 9 7.12736 9 8.49765C9 8.92563 9.21261 9.31486 9.40511 9.66725L9.4078 9.67219H6V14.9915H15V9.67219ZM15 9.67219L11.6067 9.67226C10.9478 9.67226 10 9.24388 10 8.49765C10 7.75141 10.5 6.99906 11.607 6.99906C12.7936 6.99906 14.6725 8.50361 15 9.67219ZM16 9.67219L19.3933 9.67226C20.0522 9.67226 21 9.24388 21 8.49765C21 7.75141 20.5 6.99906 19.393 6.99906C18.2064 6.99906 16.3275 8.50361 16 9.67219Z"
                    fill="url(#paint0_linear_3175_65365)"
                  ></path>
                  <path
                    d="M15 25V15.9906H6.8257V25H15Z"
                    fill="url(#paint1_linear_3175_65365)"
                  ></path>
                  <path
                    d="M16 25V15.9906H24.1743V25H16Z"
                    fill="url(#paint2_linear_3175_65365)"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_3175_65365"
                      x1="34.5045"
                      y1="15.4999"
                      x2="15.5"
                      y2="-3.50457"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF9C0E"></stop>
                      <stop offset="1" stopColor="#FFD800"></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_3175_65365"
                      x1="34.5045"
                      y1="15.4999"
                      x2="15.5"
                      y2="-3.50457"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF9C0E"></stop>
                      <stop offset="1" stopColor="#FFD800"></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_3175_65365"
                      x1="34.5045"
                      y1="15.4999"
                      x2="15.5"
                      y2="-3.50457"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF9C0E"></stop>
                      <stop offset="1" stopColor="#FFD800"></stop>
                    </linearGradient>
                  </defs>
                </svg>
                <span>
                  <Price sum={nextPrizeSpent} />
                  <span className="cur">
                    <Currency />
                  </span>
                </span>
              </div>
              <div className="case-breezy-stats-label">
                {t('case-breezy case-breezy-container case-breezy-stats-label')}
              </div>
            </div>
          )}
        </div>
        {nextRank && (
          <Link
            to={getConfig?.getEvent.getUrl}
            className="case-breezy-prize"
            data-rar={getNextItem?.color}
          >
            <div className="case-breezy-prize-labels">
              <div className="case-breezy-prize-labels-one">
                <span>{t('breezy-progress in-case-breezy-title next')}</span>
              </div>
              <div className="case-breezy-prize-labels-two">
                <span>#{nextRank}</span>
              </div>
            </div>
            <div className="top-drop-item" data-rar={getNextItem?.color}>
              <div className="honey"></div>

              <div
                className="drop-img"
                style={{
                  backgroundImage: `url('${getNextItem?.getImage}/126x62')`,
                  height: 62,
                }}
              ></div>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
};
